import logo from './logo.svg';
import './App.css';
import Navbar from './components/navbar'
import Todo from './components/todo'

function App() {
  return (
 
    <Navbar/>
    
    );
}

export default App;
